import { create } from 'zustand';
import { AccountApi, type AccountDetailsEntity, ApiUtils, RequestStrategyEnum } from '@shared/api';

interface UseAccountDetailsStore {
  loading: boolean;
  data: AccountDetailsEntity | null;
  error: string | null;
  getAccountDetails: (accountCode: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAccountDetailsStore = create<UseAccountDetailsStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getAccountDetails: ApiUtils.wrapperApi(async (accountCode, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getAccountDetails(accountCode, signal);
      set({ loading: false, data: result || null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: null, error: null }),
}));
